<template>
	<div class="view-content__wrapper">
		<div class="view-content">
			<h2 class="headline-1 mb-2">
				{{ $t("forgot_password.heading") }}
			</h2>
			<h6 class="subhead-1 mb-6">
				{{ $t("forgot_password.intro") }}
			</h6>
			<Alert v-if="getError" />
			<ValidationObserver
				v-slot="{handleSubmit}">
				<form @submit.prevent="forgotBusy ? '' : handleSubmit(forgot)">
					<ValidationProvider
						v-slot="{errors}"
						mode="passive"
						name="email"
						rules="required">
						<div class="py-4">
							<e-text-field
								v-model="username"
								large=""
								:type="usernameType"
								:label="$i18n.t('forgot_password.label')"
								:error="errors[0] && errors[0] !== ''"
								:error-messages="errors[0]" />
						</div>
					</ValidationProvider>
					<div class="d-block text-center mx-auto">
						<vue-recaptcha
							v-show="forgotShowRecaptcha"
							ref="recaptcha"
							class="recaptcha"
							:sitekey="recaptcha.siteKey"
							size="normal"
							:load-recaptcha-script="true"
							@verify="onVerify" />
					</div>
					<e-button
						class="mt-2"
						:block="true"
						type="submit"
						:loading="forgotBusy"
						variant="primary"
						size="large"
						large>
						{{ $t("forgot_password.help_me") }}
					</e-button>
				</form>
			</validationobserver>
			<div class="text-center mt-4">
				<e-button
					variant="link"
					small=""
					:block="false"
					@click="redirect()">
					{{ $t("setup_account.back_to_frontpage") }}
				</e-button>
			</div>
		</div>
	</div>
</template>

<script>
import Alert from "@/components/Alert.vue";
//import { forgotRequest, } from "../api";
import { mapGetters } from 'vuex';
import { getEnv } from '../env';
import VueRecaptcha from "vue-recaptcha";
export default {
	name: "Forgot",
	components: {
		Alert,
		VueRecaptcha,
	},
	data () {
		return {
			username: "",
			usernameType: "text",
			recaptcha: {
				recaptcha: "",
				siteKey: getEnv('VUE_APP_FRONTEND_RECAPTCHA_SITE_KEY'),
			},
		};
	},
	computed: {
		locale (){
			return this.$i18n.locale;
		},
		...mapGetters([
			'forgotBusy',
			'forgotError',
			'forgotSuccess',
			'forgotErrors',
			'forgotShowRecaptcha',
			'getError',
		]),
	},
	mounted () {
		if(getEnv('VUE_APP_FRONTEND_PROJECT_NAME') == 'Mykoob'){
			this.usernameType = 'email'
		}
	},
	methods: {
		forgot () {
			var username = this.username;
			var recaptcha = this.recaptcha.recaptcha;
			this.$store.commit("resetForgotState"); //reset state
			this.$store.dispatch('forgotPassword', { username, recaptcha }).then(
				() => {
					if(this.forgotShowRecaptcha){
						this.resetRecaptcha();
					}
					if(this.forgotError && this.forgotErrors !== undefined){
						if(this.$te("forgot_password." + this.forgotErrors)){
							this.$store.commit("changeError",
								("forgot_password." + this.forgotErrors));
							this.$store.commit("showError",true);
						}
						else{
							this.$store.commit("changeError",
								("repeating_errors." + this.forgotErrors));
							this.$store.commit("showError",true);
						}
					}
					else if(this.forgotError && this.forgotErrors == undefined){
						this.$store.commit("changeError",
							"forgot_password.user_not_found");
						this.$store.commit("showError",true);
					}
					else if(this.forgotSuccess){
						this.$router.push({
							name: "success",
							params: {
								email: this.username,
								type: "resetRequest",
							},
						});
					}
				},
			)
		},
		onVerify (response) {
			this.recaptcha.recaptcha = response;
		},
		resetRecaptcha () {
			this.recaptcha.showRecaptcha = true;
			this.$refs.recaptcha.reset(); // Direct call reset method
		},
		redirect () {
			this.$store.commit("resetForgotState");
			this.$router.push('/' + this.$i18n.locale)
		},
	},
};
</script>

<style lang="scss">
//@import "../assets/styles.scss";
</style>
